// VERIFIE 23/10/2024 !!!!! Section non vérifié plus bas

// ||
// ||
// \/

import { FilesPers, Persons } from "../interfaces";
import { Pwd } from "../interfaces/pwd.interface";
import { ObjectId } from "../types";
import {  ip } from "../utils/setup";

const PERSON_API = `${ip}/api/Person`;
const PWD_API = `${ip}/api/Pwds`;

// GET

export async function getStaffsNoHiden() {
  try {
      const response = await fetch(PERSON_API + "/noHiden", {
          credentials: "include" 
      });
    if (response.ok) {
      return response.json();
    } else {
      throw new Error(
        `Connexion au serveur impossible, code serveur: ${response.status}`
      );
    }
  } catch (e: any) {
    throw new Error(e.message);
  }
}

export async function getStaffsHiden() {
  try {
      const response = await fetch(PERSON_API + "/Hiden", {
          credentials: "include" 
      });
    if (response.ok) {
      return response.json();
    } else {
      throw new Error(
        `Connexion au serveur impossible, code serveur: ${response.status}`
      );
    }
  } catch (e: any) {
    throw new Error(e.message);
  }
}

export async function getPersonResp() {
  try {
      const response = await fetch(PERSON_API + "/nomsResp", {
          credentials: "include" 
      });
    if (response.ok) {
      return response.json();
    } else {
      if (response.status === 500) {
        throw new Error(
          `Connexion au serveur impossible, code serveur: ${response.status}`
        );
      } else if (response.status === 404) {
        throw new Error(
          `Responsable introuvable, assurez vous de posséder un responsable dans votre base de données, code serveur : ${response.status}`
        );
      } else {
        throw new Error(`Problème serveur, code serveur: ${response.status}`);
      }
    }
  } catch (e: any) {
    throw new Error(e.message);
  }
}

export async function getPersonNameId() {
  try {
      const response = await fetch(PERSON_API + "/PersonNameId", {
          credentials: "include" 
      });
    if (response.ok) {
      return response.json();
    } else {
      if (response.status === 500) {
        throw new Error(
          `Connexion au serveur impossible, code serveur: ${response.status}`
        );
      } else if (response.status === 404) {
        throw new Error(
          `Responsable introuvable, assurez vous de posséder un responsable dans votre base de données, code serveur : ${response.status}`
        );
      } else {
        throw new Error(`Problème serveur, code serveur: ${response.status}`);
      }
    }
  } catch (e: any) {
    throw new Error(e.message);
  }
}

// GET ID

export async function getFiles(_id: ObjectId): Promise<FilesPers> {
    const response = await fetch(`${PERSON_API}/${_id}/getFiles`, {
        credentials: "include" 
    });
  if (response.ok) {
    return response.json();
  } else {
    throw new Error(
      "Erreur du serveur lors de la réception de la fiche de renseignement"
    );
  }
}

// POST

export async function createStaff(
  newStaff: Partial<Persons>
): Promise<Persons> {
  const formData = new FormData();
  Object.entries(newStaff).forEach(([key, value]) => {
    if (key !== "cartId" && key !== "rib" && key !== "cartIdVerso") {
      if (typeof value === "number") {
        value = value.toFixed(3);
      }
      formData.append(key, value as string);
    }
  });
  if (newStaff.cartId instanceof FileList && newStaff.cartId.length > 0) {
    formData.append("cartId", newStaff.cartId[0]);
  } else {
    formData.append("cartId", "" as string);
  }
  if (
    newStaff.cartIdVerso instanceof FileList &&
    newStaff.cartIdVerso.length > 0
  ) {
    formData.append("cartIdVerso", newStaff.cartIdVerso[0]);
  } else {
    formData.append("cartIdVerso", "" as string);
  }
  if (newStaff.rib instanceof FileList && newStaff.rib.length > 0) {
    formData.append("rib", newStaff.rib[0]);
  } else {
    formData.append("rib", "" as string);
  }
  const response = await fetch(PERSON_API, {
    method: "POST",
      body: formData,
      credentials: "include" 
  });
  if (response.ok) {
    return response.json();
  } else {
    throw new Error("Erreur lors de la création du personnel");
  }
}

export async function createAcces(acces: Pwd) {
  const response = await fetch(PWD_API, {
      method: "POST",
      credentials: "include" ,
    headers: {
        "content-type": "application/json",
        
    },
    body: JSON.stringify(acces),
  });
  if (response.ok) {
    return response.json();
  } else {
    throw new Error(" Erreur lors de la création de l'accès utilisateur");
  }
}

//PUT

export async function updateStaff(updateStaff: Persons) {
  const { globalError, ...restStaff } = updateStaff;
  const formData = new FormData();
  Object.entries(updateStaff).forEach(([key, value]) => {
    if (key !== "cartId" && key !== "rib" && key !== "cartIdVerso") {
      formData.append(key, value as string);
    }
  });
  if (updateStaff.cartId instanceof FileList && updateStaff.cartId.length > 0) {
    formData.append("cartId", updateStaff.cartId[0]);
  } else {
    formData.append("cartId", "" as string);
  }
  if (
    updateStaff.cartIdVerso instanceof FileList &&
    updateStaff.cartIdVerso.length > 0
  ) {
    formData.append("cartIdVerso", updateStaff.cartIdVerso[0]);
  } else {
    formData.append("cartIdVerso", "" as string);
  }
  if (updateStaff.rib instanceof FileList && updateStaff.rib.length > 0) {
    formData.append("rib", updateStaff.rib[0]);
  } else {
    formData.append("rib", "" as string);
  }
  const response = await fetch(`${PERSON_API}/${restStaff.idPers}`, {
    method: "PUT",
      body: formData,
      credentials: "include" 
  });
  if (response.ok) {
    return response.ok;
  } else {
    throw new Error("Erreur lors de l'édition du personnel");
  }
}

// DELETE

export async function deleteStaff(_id: ObjectId): Promise<ObjectId> {
  const response = await fetch(`${PERSON_API}/${_id}`, {
      method: "DELETE",
      credentials: "include" 
  });
  if (response.ok) {
    return _id;
  } else {
    throw new Error("Erreur lors de la suppression du personnel ");
  }
}

// NON VERIFIE !!!!!

// ||
// ||
// \/

export async function getStaffs() {
  try {
      const response = await fetch(PERSON_API + "/Person", {
          credentials: "include" 
      });
    if (response.ok) {
      return response.json();
    } else {
      throw new Error(
        `Connexion au serveur impossible, code serveur: ${response.status}`
      );
    }
  } catch (e: any) {
    throw new Error(e.message);
  }
}

export async function getStaff(_id: ObjectId): Promise<Persons> {
    const response = await fetch(`${PERSON_API}/${_id}`, {
        credentials: "include" 
    });
  if (response.ok) {
    return response.json();
  } else {
    throw new Error("Erreur du serveur lors de la réception du personnel");
  }
}
